// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sweepstakes-callout[data-v-3057b001]{font-size:14px;background:radial-gradient(101.16% 237.07% at 6.1%,at 14.17%,#1d1a4d 0,#020025 100%);background:radial-gradient(101.16% 237.07% at 6.1% 14.17%,#1d1a4d 0,#020025 100%)}.sweepstakes-callout>div[data-v-3057b001]{align-items:center}", ""]);
// Exports
module.exports = exports;
